import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1468.2137,0 L1468.2137,551.144836 L840.269996,1179.08854 C808.646932,1210.71161 790.576609,1253.62862 790.576609,1298.80443 L790.576609,1298.80443 L790.576609,1694.09273 L1185.86491,1694.09273 C1231.04072,1694.09273 1273.95774,1676.02241 1305.5808,1644.39935 L1305.5808,1644.39935 L1468.2137,1481.76644 L1468.2137,1919.97177 L0,1919.97177 L0,0 L1468.2137,0 Z M1597.64239,581.299687 C1619.77853,559.163542 1655.46742,559.163542 1677.60356,581.299687 L1677.60356,581.299687 L1903.4826,807.178718 C1925.5058,829.201924 1925.5058,864.89081 1903.4826,887.026955 L1903.4826,887.026955 L1225.8455,1564.66405 C1215.22919,1575.16742 1200.88587,1581.15322 1185.86491,1581.15322 L1185.86491,1581.15322 L903.516125,1581.15322 L903.516125,1298.80443 C903.516125,1283.78347 909.501919,1269.44016 920.005294,1258.93678 L920.005294,1258.93678 Z M677.637094,1129.39516 L338.818547,1129.39516 L338.818547,1242.33467 L677.637094,1242.33467 L677.637094,1129.39516 Z M903.516125,903.516125 L338.818547,903.516125 L338.818547,1016.45564 L903.516125,1016.45564 L903.516125,903.516125 Z M1637.62298,701.015573 L1548.06194,790.576609 L1694.09273,936.607403 L1783.65377,847.046367 L1637.62298,701.015573 Z M1129.39516,338.818547 L338.818547,338.818547 L338.818547,677.637094 L1129.39516,677.637094 L1129.39516,338.818547 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAssignmentSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAssignmentSolid, _Component);

  var _super = _createSuper(IconAssignmentSolid);

  function IconAssignmentSolid() {
    _classCallCheck(this, IconAssignmentSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAssignmentSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAssignment",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconAssignmentSolid.displayName = "IconAssignmentSolid";
  return IconAssignmentSolid;
}(Component);

IconAssignmentSolid.glyphName = 'assignment';
IconAssignmentSolid.variant = 'Solid';
IconAssignmentSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAssignmentSolid;
export { IconAssignmentSolid };